import { Routes } from '@angular/router';
import { PurpleFitSelectBrokerComponent } from './app-purple-fit-broker-select-broker/purple-fit-select-broker.component';
import { environment } from '../environments/default/environment';

let lan = localStorage.getItem('Language')?.replaceAll('"', "") ?? environment.DEFAULT_LANGUAGE;

export const brokerRoutes: Routes = [
  {
    path: '',
    redirectTo: lan+'/fit-selection',
    pathMatch: 'full'
  },
  {
    path: ':cultureId',
    children: [
      {
        path: '',
        redirectTo: 'fit-selection',
        pathMatch: 'full'
      },
      {
        path: 'fit-selection',
        component: PurpleFitSelectBrokerComponent
      }
    ]
  }
];
